<template>
    <div>
        <div class="content-header">
            <PageTitleComponent v-if="title" :title="title"/>
        </div>

        <section class="content">
            <div class="container-fluid">
                <div :class="format === 'card' ? 'card' : ''">
                    <div class="my-3 text-center text-lg-left">
                        <div :class="format == 'card' ? 'card-header' : 'content-header'">
                            <div class="d-md-flex justify-content-md-between">
                                <slot name="header"></slot>
                            </div>
                        </div>
                    </div>
                    <div v-if="$slots.subheader" :class="format == 'card' ? 'card-header' : 'content-header'">
                        <slot name="subheader"></slot>
                    </div>
                    <div :class="format == 'card' ? 'card-body p-0' : ''">
                        <slot name="content"><LoaderComponent/></slot>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import PageTitleComponent from '@/components/backend/components/PageTitleComponent';

    export default {
        props: {
            title: String,
            format: {
                type: String,
                default: 'card',
                validator: value => ['card', 'plain'].includes(value)
            }
        },
        components: {
            LoaderComponent, PageTitleComponent
        }
    }
</script>